import React from "react";

/**
 * Sun & Weather Protection icon — two overlapping shields. On tile hover the outer
 * shield grows a little while the inner one shrinks, so it "splits" into two
 * layers (and gets a soft green glow); it holds while hovered and returns on
 * leave (see serviceIcons.css). Edit freely; uses currentColor.
 */
const SHIELD = "M24 5 L39 10 V22 C39 32 32 39.5 24 43 C16 39.5 9 32 9 22 V10 Z";

const ServiceShieldIcon = () => (
  <svg
    className="bdrv2-svc-ico bdrv2-ico-shield"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path className="bdrv2-ico-shield-outer" d={SHIELD} />
    <path className="bdrv2-ico-shield-inner" d={SHIELD} />
  </svg>
);

export default ServiceShieldIcon;
